import { FC } from 'react'
import { useController } from 'react-hook-form'

import { TextField } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation/useLocalisation'

type TextFormFieldProps = {
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
}

export const TextFormField: FC<TextFormFieldProps> = (props) => {
  const { name, label, required, disabled } = props
  const { field, fieldState } = useController({ name })
  const { translate, isValidTranslationKey } = useLocalisation()

  const hint = !fieldState.error?.message
    ? undefined
    : isValidTranslationKey(fieldState.error.message)
      ? translate(fieldState.error.message)
      : fieldState.error.message

  return (
    <TextField
      {...field}
      name={name}
      label={label}
      required={required}
      disabled={disabled}
      state={fieldState.error ? 'negative' : undefined}
      hint={hint}
    />
  )
}
